import goodFace from 'images/icons/GoodfaceLogo.svg';
import './footer.scss';
import RouterLink from 'components/RouterLink';
import Logo from 'components/Logo';
import { useSelector } from 'react-redux';
import { selectMainProducts } from 'store/slices/ProductsSlice';
import { Link } from 'react-router-dom';
import { ROUTES } from 'constants/routes';
import { selectTranslations } from 'store/slices/GeneralTranslationsSlice';

const Footer = () => {
    const products = useSelector(selectMainProducts);
    const {
        footer_description_text,
        menu_company_text,
        menu_about_text,
        menu_news_text,
        menu_career_text,
        menu_contacts_text,
        menu_products_text,
        menu_resources_text,
        menu_crop_nutrition_text,
        menu_trial_results_text,
        menu_information_materials_text,
        footer_social_media_text,
        footer_contacts_email_text,
        footer_contacts_phone_text,
        footer_contacts_address_text,
        footer_copyright_text,
        footer_terms_conditions_text,
        footer_legal_info_text,
        footer_instagram_link,
        footer_facebook_link,
        footer_youtube_link,
    } = useSelector(selectTranslations);
    return (
        <footer className="container">
            <div className="footer">
                <div className="footer-upper-section">
                    <div className="footer-start">
                        <div className="logo">
                            <Logo />
                        </div>
                        <p className="description-medium">{footer_description_text}</p>
                    </div>
                    <div className="company-data-wrapper">
                        <div className="company-information">
                            <div>
                                <p className="body1">{menu_company_text}</p>
                                <RouterLink pathName="aboutUs">{menu_about_text}</RouterLink>
                                <RouterLink pathName="news">{menu_news_text}</RouterLink>
                                <RouterLink pathName="career">{menu_career_text}</RouterLink>
                                <RouterLink pathName="contacts">{menu_contacts_text}</RouterLink>
                            </div>
                            <div>
                                <p className="body1">{menu_products_text}</p>
                                {products.map(product => (
                                    <Link
                                        to={ROUTES.products + '/' + product.slug}
                                        className="button-text"
                                        key={product.slug}
                                    >
                                        {product.preview_title}
                                    </Link>
                                ))}
                            </div>
                            <div>
                                <p className="body1">{menu_resources_text}</p>
                                <RouterLink pathName="cropNutritionPrograms">{menu_crop_nutrition_text}</RouterLink>
                                <RouterLink pathName="trialResults">{menu_trial_results_text}</RouterLink>
                                <RouterLink pathName="informationMaterials">
                                    {menu_information_materials_text}
                                </RouterLink>
                            </div>
                        </div>
                        <div className="footer-contacts">
                            <div>
                                <p className="body1">{footer_social_media_text}</p>
                                <div>
                                    <Link target="_blank" to={footer_instagram_link} className="button instagram" />
                                    <Link target="_blank" to={footer_facebook_link} className="button facebook" />
                                    <Link target="_blank" to={footer_youtube_link} className="button youtube" />
                                </div>
                            </div>
                            <div>
                                <p className="body1">{menu_contacts_text}</p>
                                <a href={`mailto:${footer_contacts_email_text}`} className="button-text mail">
                                    {footer_contacts_email_text}
                                </a>
                                <a href={`tel:${footer_contacts_phone_text}`} className="button-text phone">
                                    {footer_contacts_phone_text}
                                </a>
                                <a href="/#" className="button-text map-pin">
                                    {footer_contacts_address_text}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-lower-section">
                    <p className="body1 copyright">{footer_copyright_text}</p>
                    <div className="policies">
                        <RouterLink pathName="termsAndConditions">{footer_terms_conditions_text}</RouterLink>
                        <RouterLink pathName="legalInfo">{footer_legal_info_text}</RouterLink>
                    </div>
                    <p className="goodface-bar">
                        <span className="body1">Created by</span>{' '}
                        <span className="goodface">
                            <a href="https://goodface.agency" target="_blank" rel="noreferrer">
                                Goodface
                                <img src={goodFace} alt="Goodface logo" />
                            </a>
                        </span>
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
